/** @format */

import { getUser, getAdmin } from '@/plugins/auth';
import { NODE_ENV } from '@/config';

const verifyCompany = () => {
	let company = '';
	if (getAdmin()) company = getAdmin()._id;
	else if (getUser()) {
		if (getUser()._id) company = getUser()._id;
	}
	if (getUser().ownerId) company = getUser().ownerId;
	if (company == '604a6d01e1427c000ac3abd9' && NODE_ENV != 'development') {
		localStorage.setItem('empresa', 'agroservices');
		return `https://agroservices-frontend-dot-plhain.rj.r.appspot.com/#/auth`;
	}
	if (company == '605a29958383a3000bbd08a8' && NODE_ENV != 'development') {
		localStorage.setItem('empresa', 'ciclourbano');
		return `https://ciclourbano-frontend-dot-plhain.rj.r.appspot.com/#/auth`;
	}
	if (company == '60ba39cf625db9000a06900c' && NODE_ENV != 'development') {
		localStorage.setItem('empresa', 'biotec');
		return `https://biotec-frontend-dot-plhain.rj.r.appspot.com/#/auth`;
	}
	if (company == '60ff350087dc12000a28ad9d') {
		localStorage.setItem('empresa', 'rrplagas');
		return `https://rrplagas-frontend-dot-plhain.rj.r.appspot.com/#/auth`;
	}
	localStorage.setItem('empresa', '');
	return false;
};

export { verifyCompany };
